import actionTypes from './actionTypes'

const activitiesActions = {
	mcqMounted(questionUid) {
		return {
			type: actionTypes.ACTIVITY_MCQ_MOUNTED,
			questionUid,
		}
	},
	mcqStudentMounted(questionUid) {
		return {
			type: actionTypes.ACTIVITY_MCQ_STUDENT_MOUNTED,
			questionUid,
		}
	},
	mcqUnmounted(questionUid) {
		return {
			type: actionTypes.ACTIVITY_MCQ_UNMOUNTED,
			questionUid,
		}
	},
	mcqStatusFetched(activity) {
		return {
			type: actionTypes.ACTIVITY_MCQ_STATUS_FETCHED,
			activity,
		}
	},
	oeqStudentMounted(questionUid) {
		return {
			type: actionTypes.ACTIVITY_OEQ_STUDENT_MOUNTED,
			questionUid,
		}
	},
	oeqStatusFetched(activity) {
		return {
			type: actionTypes.ACTIVITY_OEQ_STATUS_FETCHED,
			activity,
		}
	},
	oeqMounted(questionUid) {
		return {
			type: actionTypes.ACTIVITY_OEQ_MOUNTED,
			questionUid,
		}
	},
	oeqUnmounted(questionUid) {
		return {
			type: actionTypes.ACTIVITY_OEQ_UNMOUNTED,
			questionUid,
		}
	},
}

export default activitiesActions
